export const REFUND_REASON_MAP: Record<string, string> = {
	AMOUNT_LESS_THAN_MIN_AMOUNT_OUT:
		"The configured slippage tolerance is insufficient",
	AMOUNT_MORE_THAN_BALANCE:
		"Quoted amount + fees is greater than quote's amount in",
	INTENT_SUBMIT_FAILED: "Internal error occurred (intent submission failed)",
	PARTIAL_DEPOSIT: "Deposited amount is less than quoted amount in",
	CIRCUIT_BREAKER_BLOCKED: "Failed to get quote",
	FEE_ESTIMATION_FAILED: "Withdrawal fee estimation failed",
	NO_LIQUIDITY: "Deadline passed",
	AMOUNT_LESS_THAN_MIN_WITHDRAWABLE:
		"Quoted amount is less than minimum withdrawable amount + fees",
	INSUFFICIENT_BALANCE: "Insufficient balance",
	REFUND_ADD_FAILED: "Refund add failed",
	UNKNOWN: "Unknown",
};
